// extracted by css-extract-rspack-plugin
export default {"IssueDetailContainer":"IssueDetail-module__IssueDetailContainer__B7c8je4"};